/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import customStyles from "../../../../../assets/styles/customStyles";
import { PriceCustomerListHead, PriceCustomerListHeadSorting } from "../../../../../config/constant";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { getColumnWidth, capitalizeFirstLetter } from "../../../../../helpers/utilities";


export const CustomerListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, view,
        details, loadMore, loadMoreContent, loadMoreTask, selected, handleSelected } = props;



    const isSelected = (name) => selected.indexOf(name) !== -1;


    useEffect(() => {
        if (details && details.length > 0) {
            const newSelecteds = details.filter((el) => { return el.inAppStatus === 'ACCEPTED' }).map((n) => n.id);
            if (handleSelected) {
                handleSelected(newSelecteds)
            }
        }
    }, [details]);


    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        handleSelected(newSelected);
    };

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={view ? PriceCustomerListHead.slice(1) : PriceCustomerListHeadSorting}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            selected={selected}
            onSelected={(value) => handleSelected(value)}
            width={true}
            details={details && details.filter((el) => { return el.inAppStatus === 'ACCEPTED' })}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            onClick={(e) => { if (data.inAppStatus === 'ACCEPTED') { handleClick(e, data.id) } }}>
                                            <TableCell className={clsx('checkbox', classes.tablealign)} padding="checkbox">
                                                {
                                                    data.inAppStatus === 'ACCEPTED' ? <Checkbox color="primary" checked={isSelected(data.id)} /> : <div className={classes.squareBox}></div>
                                                }
                                            </TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(PriceCustomerListHead, 0) }}>
                                                <div style={{ width: getColumnWidth(PriceCustomerListHead, 0) }} className={clsx(classes.positionRelative)}>{data.name}</div>
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 1) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 1) }}>{data?.serialNo || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}>{data.mobile}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 3) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}>{data?.customerBusiness?.serialNo}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 4) }}><span className={classes.textAlignLeft} style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}>{data?.inAppStatus ? capitalizeFirstLetter(data?.inAppStatus) : 'Rejected'}</span></TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'There are no customers in your list. Please try after adding the customers'}</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}